"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ref = ref;
const Authorization_1 = require("./Authorization");
const ModelField_1 = require("./ModelField");
const brandName = 'ref';
function brandedBuilder(builder) {
    return builder;
}
function _ref(link) {
    const data = {
        type: 'ref',
        link,
        valueRequired: false,
        array: false,
        arrayRequired: false,
        mutationOperations: [],
        authorization: [],
    };
    const builder = brandedBuilder({
        required() {
            if (data.array) {
                data.arrayRequired = true;
            }
            else {
                data.valueRequired = true;
            }
            return this;
        },
        array() {
            data.array = true;
            return this;
        },
        authorization(callback) {
            const rules = callback(Authorization_1.allow);
            data.authorization = Array.isArray(rules) ? rules : [rules];
            return this;
        },
        mutations(operations) {
            data.mutationOperations = operations;
            return this;
        },
    });
    return { ...builder, data };
}
function ref(link) {
    return _ref(link);
}
